import React, { Component, useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import ImageOnly from './ArticleRendering/ImageOnly'
import TextAboveImage from './ArticleRendering/TextAboveImage';
import TextBelowImage from './ArticleRendering/TextBelowImage';
import TextLeftImage from './ArticleRendering/TextLeftImage';
import TextRightImage from './ArticleRendering/TextRightImage';
import TextOnly from './ArticleRendering/TextOnly';
// import SearchField from './ArticleRendering/SearchField';
// import Accordion from './ArticleRendering/Accordion';
import TextOverImage from './ArticleRendering/TextOverImage';
import LinkOnly from './ArticleRendering/LinkOnly';
import Accordian from './ArticleRendering/Accordion';
import './ArticleRendering/Accordion.css';
import HtmlRawContainerArticle from './HtmlRawContainerArticle';


function renderSwitch(renderType, articleObj) {
  switch (renderType) {
    //   case 'Accordion':
    //     return <Accordion articleObj={articleObj}></Accordion>
    case 'ImageOnly':
      return <ImageOnly articleObj={articleObj}></ImageOnly>
    case 'TextAboveImage':
      return <TextAboveImage articleObj={articleObj}></TextAboveImage>
    case 'TextBelowImage':
      return <TextBelowImage articleObj={articleObj}></TextBelowImage>
    case 'TextOverImage':
      return <TextOverImage articleObj={articleObj}></TextOverImage>
    case 'TextRightImage':
      return <TextRightImage articleObj={articleObj}></TextRightImage>
    case 'TextLeftImage':
      return <TextLeftImage articleObj={articleObj}></TextLeftImage>
    case 'LinkOnly':
      return <LinkOnly articleObj={articleObj}></LinkOnly>
    case 'Accordion':
      return <Accordian articleObj={articleObj}></Accordian>
    case 'ClientPage':
      return <ClientContainer articleObj={articleObj}></ClientContainer>
    case 'rawHtml':
      return <HtmlRawContainerArticle articleObj={articleObj}></HtmlRawContainerArticle> 
    case 'OurTeam':
          return <OurTeam articleObj={articleObj}></OurTeam>   
 default:
      return <TextOnly articleObj={articleObj}></TextOnly>;
  }
}
function Article(props) {
  useEffect(() => {
    var hash = window.location.hash;
    if (hash) {
      var element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

  }, [])

  var articleObj = props.articleObj
  var renderType = articleObj.attributes.renderType

  return (
    renderSwitch(renderType, articleObj)
  )
}

export default Article
